import { useContext, type ReactNode } from "react"
import { WebBootContext } from "source/publishing/WebBoot"
import { Error404 } from "source/shared/components/Error404"

interface Props {
  identifier: string
  children: ReactNode
  fallback?: ReactNode
}

export function PublishedPageGuard({
  identifier,
  children,
  fallback = <Error404 />,
}: Props) {
  const { builtInPages } = useContext(WebBootContext)
  const isPublished = builtInPages[identifier] === "published"

  return isPublished ? <>{children}</> : <>{fallback}</>
}
